import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CPQScreenOption } from '../../../models/CPQUI';


@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {
  @Output() SelectOnChangeEmitter: EventEmitter<any> = new EventEmitter();
  CurrentScreenOption: CPQScreenOption;
  constructor() { }

  ngOnInit(): void {
  }

  SetControl(control: CPQScreenOption) {
    if (control.Name.indexOf("YM") == 0) {
      var tempIndex = control.SelectableValues;//.filter(x => x.Caption.substring(0, 1) != 'I' && x.Caption.substring(0, 1) != 'S' && x.Caption.substring(0, 1) != 'V');
      if (tempIndex[0].Value == '00') {
        var disposeOfTemp = tempIndex.shift();
      }
      tempIndex.sort((first, second) => {
        var cleanFirst = first.Caption.substr(first.Caption.indexOf(":"));
        var cleanSecond = second.Caption.substr(second.Caption.indexOf(":"));


        if (cleanFirst < cleanSecond) {
          return -1;
        }
        else if (cleanFirst > cleanSecond) {
          return 1;
        }

        return 0;
      });
      if (disposeOfTemp) {
        tempIndex.unshift(disposeOfTemp);
      }
      control.SelectableValues = tempIndex;
    }

    this.CurrentScreenOption = control;
  }

  selectOnChange(event: any, autoContinueMode: number) {
    this.CurrentScreenOption.Value = event.target.value;
    this.SelectOnChangeEmitter.emit(this.CurrentScreenOption);
  }

}
